export enum OrderViewTabs {
  OFFER = 'offer',
  EVENTS = 'events',
  COMMENTS = 'comments',
  MARGIN = 'margin',
  Preparation = 'Klargjøring',
}

export enum ConfigurationStatus {
  VERIFYING = "verifying",
  INVALID = "invalid",
  VALID = "valid",
  ERROR = "error"
}